export const goToVFair = (attendee: any) => {
    const vFairsLink = document.createElement('a')
    vFairsLink.setAttribute('href', attendee?.eventAttendee?.metaData?.loginUrl)
    vFairsLink.setAttribute('target', '_blank')
    vFairsLink.click()
}